<script>
import Vue from 'vue'
import { VTextarea } from 'vuetify/lib'
import ETextFieldBase from '../ETextField'
import { VTextField } from 'vuetify/lib/components'

const ETextField = Vue.extend(ETextFieldBase)

export default {
  name: 'ETextarea',
  mixins: [VTextarea, ETextField],
  props: {
    autoGrow: {
      type: Boolean,
      default: true,
    },
    noResize: {
      type: Boolean,
      default: true,
    },
    rowHeight: {
      type: [Number, String],
      default: 24,
      validator: (v) => !isNaN(parseFloat(v)),
    },
    rows: {
      type: [Number, String],
      default: 5,
      validator: (v) => !isNaN(parseInt(v, 10)),
    },
  },
  computed: {
    classes() {
      return {
        'e-textarea': true,
        ...ETextField.options.computed.classes.call(this),
        'v-textarea': true,
        'v-textarea--auto-grow': this.autoGrow,
        'v-textarea--no-resize': this.noResizeHandle,
      }
    },

    noResizeHandle() {
      return this.noResize || this.autoGrow
    },
  },

  methods: {
    genDefaultSlot() {
      return [this.genFieldset(), this.genTextFieldSlot()]
    },
    genInput() {
      const input = VTextField.options.methods.genInput.call(this)
      input.tag = 'textarea'
      delete input.data.attrs.type
      input.data.attrs.rows = this.rows
      return input
    },

    onInput(e) {
      VTextField.options.methods.onInput.call(this, e)
      this.autoGrow && this.calculateInputHeight()
    },

    onKeyDown(e) {
      // Prevents closing of a
      // dialog when pressing
      // enter
      if (this.isFocused && e.keyCode === 13) {
        e.stopPropagation()
      }

      this.$emit('keydown', e)
    },
  },
}
</script>
